// extracted by mini-css-extract-plugin
export var searchHeader = "_3j-0";
export var searchHeaderDark = "_3j-1";